// eslint-disable-next-line max-len
import { createReactComponent } from '@railzai/railz-visualizations-react/dist/cjs/components/stencil-generated/react-component-lib/createComponent.js';

import { defineCustomElements } from 'helpers/railz-visualizations-loader';

defineCustomElements();

export const RailzBankReconciliation = createReactComponent('railz-bank-reconciliation');
export const RailzBusinessValuations = createReactComponent('railz-business-valuations');
export const RailzCreditScore = createReactComponent('railz-credit-score');
export const RailzGaugeChart = createReactComponent('railz-gauge-chart');
export const RailzFinancialRatios = createReactComponent('railz-financial-ratios');
export const RailzIncomeStatements = createReactComponent('railz-income-statements');
export const RailzProgressBar = createReactComponent('railz-progress-bar');
export const RailzStatementsChart = createReactComponent('railz-statements-chart');
export const RailzTaxBenchmarking = createReactComponent('railz-tax-benchmarking');
export const RailzTransactionsControl = createReactComponent('railz-transactions-control');
